import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import { FontIcon } from 'material-ui';
var styles = {
    icon: {
        color: 'rgba(0,0,0,.54)'
    }
};
var TaskStatusMenu = /** @class */ (function (_super) {
    tslib_1.__extends(TaskStatusMenu, _super);
    function TaskStatusMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (statusId) {
            if (_this.props.task.statusId !== statusId) {
                _this.props.task.setStatus(statusId);
            }
        };
        return _this;
    }
    TaskStatusMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, task = _a.task, taskStore = _a.taskStore;
        var menuItems = taskStore.statuses.map(function (i) {
            return React.createElement(MenuItem, { key: i.id, value: i.id, primaryText: i.name, style: { color: task.statusId === i.id ? 'rgb(0, 188, 212)' : 'inherit' }, onClick: function () { return _this.handleClick(i.id); } });
        });
        var trigger = React.createElement(IconButton, { iconStyle: styles.icon },
            React.createElement(FontIcon, { className: "material-icons" }, "send"));
        return (React.createElement(IconMenu, { iconButtonElement: trigger, anchorOrigin: { horizontal: 'right', vertical: 'bottom' }, targetOrigin: { horizontal: 'right', vertical: 'bottom' } }, menuItems));
    };
    TaskStatusMenu = tslib_1.__decorate([
        inject('taskStore'),
        observer
    ], TaskStatusMenu);
    return TaskStatusMenu;
}(React.Component));
export { TaskStatusMenu };



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskStatusMenu.tsx
// module id = 776
// module chunks = 0